export default "__VITE_ASSET__DEWjPNHh__"